import React, { useState, useEffect } from "react";
import AppRoute from "./Route/AppRoute";
import InquiryModal from "./component/enquiry_model";
import "./App.css"
function App() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setOpen(false); // Open modal when page loads
      
    }, 3000);
  }, []);

  return (
    <>
      <AppRoute />
      <InquiryModal open={open} handleClose={() => setOpen(false)} />
    </>
  );
}

export default App;
